import { deleteJSON, postJSON, putJSON } from 'api/fetch';

import { NAVIGATION } from 'util/navigation';

type SmsOtpType = {
  phone: string;
};

/*
 * This action should be used for Phone sign in only
 * For mfa flows, use sendMfaSmsOtp in util/stych.ts
 */
export const sendSmsOtp = (body: SmsOtpType) =>
  postJSON('/authentication/mfa/sms-otp', body);

type EmailOtpType = {
  email: string;
};
export const sendEmailOtp = (body: EmailOtpType) =>
  postJSON('/authentication/mfa/email-otp', body);

type NewPasswordType = {
  password: string;
};

export const updatePassword = (body: NewPasswordType) =>
  putJSON('/authentication/users/password', body);

export const signOutUser = () => deleteJSON(NAVIGATION.ACCOUNT_SIGN_OUT);
